module.exports = __webpack_public_path__ + "static/logo-gray.c578842d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-gray.svg
// module id = 473
// module chunks = 168707334958949